/**
 * tRPC React Hooks
 */
import { createTRPCReact } from '@trpc/react-query'
import type { AppRouter } from '../../../server/api/src/trpc/routers/_app'

export const trpc = createTRPCReact<AppRouter>()
